// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__1faEn","socialIcon":"Social_socialIcon__Ixm9m"};